module.exports = __webpack_public_path__ + "img/2.b565872.png";